module.exports = __webpack_public_path__ + "img/big-warning-red.5678931f.svg";